<section class="technology" id="technology">
  <div class="technology__grid"></div>
  <div class="blob blob-1"></div>
  <div class="blob blob-2"></div>

  <div class="container">
    <div class="technology__header">
      <span class="section-tag">{{ t().tech_tag }}</span>
      <h2 class="section-title">{{ t().tech_title }}<br><span>{{ t().tech_subtitle }}</span></h2>
    </div>

    <!-- Architecture pipeline -->
    <div class="tech-pipeline">
      <div class="pipeline-step" *ngFor="let step of steps(); let i = index">
        <div class="step-dot"></div>
        <div class="step-content">
          <span class="step-num">{{ i + 1 < 10 ? '0' + (i + 1) : i + 1 }}</span>
          <span class="step-label">{{ step }}</span>
        </div>
        <div class="step-arrow" *ngIf="i < steps().length - 1">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2 6h8M6 2l4 4-4 4" stroke="rgba(0,102,204,0.4)" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
      </div>
    </div>

    <!-- Features grid -->
    <div class="tech-features">
      <div class="tech-feat" *ngFor="let f of features()">
        <span class="tech-feat__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#0066cc" stroke-width="1.5"/>
            <path d="M12 8v4l3 3" stroke="#0066cc" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
        <h4>{{ f.title }}</h4>
        <p>{{ f.desc }}</p>
      </div>
    </div>

    <!-- Tech stack visual -->
    <div class="tech-stack">
      <div class="stack-layer" *ngFor="let layer of layers()" [style.--layer-color]="layer.color">
        <span class="layer-dot"></span>
        <span class="layer-name">{{ layer.name }}</span>
        <span class="layer-arrow">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 4v8M4 8l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
      </div>
    </div>
  </div>
</section>